import { gql, useMutation } from '@apollo/client';

import type { UpsertResidenceMutation, UpsertResidenceMutationVariables } from './__generated__/useUpsertResidence.gql';

const UPSERT_RESIDENCE = gql`
  mutation UpsertResidence($input: UpsertResidenceInput!) {
    upsertResidence(input: $input) {
      id
      isPrimary
      residenceType
      residenceTypeOther
      addressLine1
      addressLine2
      city
      state
      postalCode
      country
      placeId
      formatted
      ownership
      ownershipOther
    }
  }
`;

/**
 * Creates or updates a family `Residence`. With `input.residenceId` Apollo's
 * normalized cache merges the returned fields automatically — the `User` /
 * `Dependant` entity's `primaryResidence` reference is unchanged, only the
 * entity it points to. On a create, callers should refetch the query that
 * selects the relevant `primaryResidence` / `otherResidences` (e.g.
 * `useOnboardingState().refetch()`) so the reference flips from `null` to the
 * new row.
 *
 * The selection is the superset both onboarding consumers need:
 * `UserResidenceStep` reads the base address fields, and
 * `DependantResidenceStep` additionally writes `residenceTypeOther` /
 * `ownership` / `ownershipOther`, so all three ride back in the response to
 * keep the cache row complete.
 */
export const useUpsertResidence = () => {
  return useMutation<UpsertResidenceMutation, UpsertResidenceMutationVariables>(UPSERT_RESIDENCE);
};
